/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { GrFormClose } from "react-icons/gr";

import { toast } from "react-toastify";
import * as Styles from "./styles";
import * as SVGIcons from "../../assets/iconsSVG";
import CustomTooltip from "../CustomTooltip/CustomToolTip.component";
import ToolTipContainer from "./components/ToolTipContainer";

interface Props {
  onChangeValue: (val: any) => void;
}

const UploadButton: React.FC<Props> = (props) => {
  const [fileData, setFileData] = useState<{
    nome: string;
    tipoArquivo: string;
    tamanhoArquivo: string;
    base64: string;
  } | null>(null);

  useEffect(() => {
    props?.onChangeValue(fileData || null);
  }, [fileData]);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const validFileTypes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      const file = files[0];
      const fileType = file.type;

      if (validFileTypes.includes(fileType)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = e.target?.result as string;
          const fileSizeKB = (file.size / 1024).toFixed(2);
          const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

          setFileData({
            nome: file.name,
            tipoArquivo: fileType,
            tamanhoArquivo:
              file.size < 1024
                ? `${file.size} bytes`
                : file.size < 1024 * 1024
                ? `${fileSizeKB} KB`
                : `${fileSizeMB} MB`,
            base64: base64Data,
          });
        };
        reader.readAsDataURL(file);
      } else {
        toast.error(
          "Por favor, selecione apenas imagens ou documentos válidos."
        );
      }
    }
  };

  const removeItem = () => {
    setFileData(null);
  };

  return (
    <Styles.Container>
      {fileData === null ? (
        <Styles.FileUploadButtonWrapper>
          <label htmlFor="file-upload">
            <input
              type="file"
              id="file-upload"
              style={{ display: "none", cursor: "pointer" }}
              onChange={handleFileUpload}
            />
            <Styles.Row>
              <SVGIcons.UploadIconGraySharp />
              <Styles.FileUploadText>Carregar anexo</Styles.FileUploadText>
            </Styles.Row>
          </label>
        </Styles.FileUploadButtonWrapper>
      ) : null}
      <Styles.ContainerWrapper>
        <Styles.ContainerFiles>
          {fileData !== null && (
            <>
              <CustomTooltip title={<ToolTipContainer data={fileData} />}>
                <Styles.File>
                  <Styles.FileUploadText>{fileData.nome}</Styles.FileUploadText>
                  <IconButton size="small" onClick={removeItem}>
                    <GrFormClose />
                  </IconButton>
                </Styles.File>
              </CustomTooltip>
              <Styles.FileUploadButtonWrapperSmall>
                <label htmlFor="file-upload">
                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: "none", cursor: "pointer" }}
                    onChange={handleFileUpload}
                  />
                  <Styles.Row>
                    <SVGIcons.UploadIconGraySharp />
                  </Styles.Row>
                </label>
              </Styles.FileUploadButtonWrapperSmall>
            </>
          )}
        </Styles.ContainerFiles>
      </Styles.ContainerWrapper>
    </Styles.Container>
  );
};

export default UploadButton;
